<template>
  <div class="standalone-auth">
    <div class="standalone-auth__card">
      <LogoTile :src="logoUrl" :alt="tenantName" :size="56" />
      <h1 class="standalone-auth__title">{{ tenantName }}</h1>
      <p v-if="errorMessage" class="standalone-auth__error">{{ errorMessage }}</p>
      <v-btn color="primary" size="large" block :loading="loading" @click="signIn">Sign in</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useTheme } from "vuetify";
import { useSessionStore } from "@/stores/session";
import LogoTile from "@/shell/LogoTile.vue";

export default defineComponent({
  name: "Login",
  components: { LogoTile },
  setup() {
    const session = useSessionStore();
    const theme = useTheme();
    const loading = ref(false);
    const errorMessage = computed(() => session.errorMessage);

    const tenantName = computed(() => session.tenant?.name || "MetaShip");
    const logoUrl = computed(() => {
      const branding = session.tenant?.branding;
      return (theme.global.current.value.dark ? branding?.logoDarkUrl : branding?.logoLightUrl) || null;
    });

    async function signIn(): Promise<void> {
      loading.value = true;
      try {
        await session.beginLogin();
      } finally {
        loading.value = false;
      }
    }

    return { tenantName, logoUrl, loading, errorMessage, signIn };
  },
});
</script>

<style scoped>
.standalone-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.standalone-auth__card {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}
.standalone-auth__title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}
.standalone-auth__error {
  color: rgb(var(--v-theme-error));
  font-size: 13px;
  margin: -8px 0 0;
}
</style>
